module.exports = "../../img/modal-header.png?ffea1c349c87c804c3c33cfec009db7b";


//////////////////
// WEBPACK FOOTER
// ./WebResources/vue/shared/components/BouncePreventor/assets/modal-header.png
// module id = 279
// module chunks = 1 2 6 7 8 9